import styled from 'styled-components';
import { color, size } from '../helpers/variables';
import { Paragraph } from '../Paragraph';
import { dynamicFontSize, fontFamilyHeading } from '../helpers/mixins';

export const DesignerCardHeading = styled.h2`
  margin: 0 0 20px;
  ${fontFamilyHeading};
  font-size: 30px;
  font-weight: 400;
  text-align: center;
  line-height: 1.25;
  @media screen and (min-width: ${size.xXLarge}px) {
    font-size: 40px;
  }
`;

export const DesignerCardBody = styled.p`
  margin: 0 0 40px;
  font-size: 14px;
  text-align: center;
  line-height: 1.75;
`;

export const DesignerCardParagraph = Paragraph.extend`
  ${dynamicFontSize(14, 16)};
  text-align: center;
  line-height: 1.79;
  margin: 47px 0;
`;

export const DesignerCardImageContainer = styled.div`
  flex: 1;
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;

  @media screen and (min-width: ${size.large}px) {
    padding-bottom: 0;
    height: auto;
  }
`;

export const DesignerCardImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  object-fit: cover;
`;

export const DesignerCardName = styled.p`
  display: block;
  position: relative;

  span {
    display: block;
    padding: 9px 0 0;
    font-size: 12px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 1.5px;
    text-align: center;
    color: ${color.black};
    text-transform: uppercase;
  }

  &:before {
    content: '';
    display: inline-block;
    height: 1px;
    width: 100%;
    background-color: ${color.black};
  }

  &:after {
    content: '';
    display: inline-block;
    height: 1px;
    width: 100%;
    background-color: ${color.black};
  }

  @media screen and (min-width: ${size.large}px) {
    span {
      padding: 12px 0 0;
    }
  }
`;

export const DesignerCardRootContainer = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  align-items: stretch;
  flex-direction: column-reverse;

  @media screen and (min-width: ${size.large}px) {
    flex-direction: row;
  }
`;

export const DesignerCardContent = styled.div`
  flex: 1;
  background-color: ${color.white};

  @media screen and (min-width: 1300px) {
    height: 0;
    padding-bottom: 50%;
    position: relative;
  }
`;

export const DesignerCardContentContainer = styled.div`
  width: 100%;
  height: auto;
  background: ${color.white};
  padding: 44px 24px;

  @media screen and (min-width: 440px) {
    padding: 44px;
  }

  @media screen and (min-width: ${size.large}px) {
    padding: 68px 68px 87px;
  }

  @media screen and (min-width: 1300px) {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-top: 0;
    padding-bottom: 20px;
  }
`;

export const DesignerCardPortrait = styled.img`
  display: block;
  width: 80px;
  height: 80px;
  border-radius: 100%;
  margin: 10px auto;

  @media screen and (min-width: 400px) {
    width: 110px;
    height: 110px;
  }

  @media screen and (min-width: ${size.large}px) {
    width: 130px;
    height: 130px;
  }
`;



// WEBPACK FOOTER //
// ./src/styles/blocks/DesignerCardBlock.js